import { defineMessages, useIntl } from 'react-intl';

import { Button } from '~/eds/src/components/Button/Button';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';

export type AddToGroupStepType = 'select-items' | 'select-parent';

export interface AddItemsFooterProps {
  selectedIds: string[];
  step: AddToGroupStepType;
  onBack: () => void;
  onNext: () => void;
}

const messages = defineMessages({
  cancel: {
    id: 'AddItemsPanel.cancel',
    defaultMessage: 'Cancel',
    description: 'Button text to cancel',
  },
  nextLink: {
    id: 'AddItemsPanel.nextLink',
    defaultMessage: 'Next: Link',
    description: 'Button text for next step to link items',
  },
  back: {
    id: 'AddItemsPanel.back',
    defaultMessage: 'Back',
    description: 'Button text for previous step',
  },
  addItems: {
    id: 'AddItemsPanel.addItems',
    defaultMessage: 'Add Items',
    description: 'Button text to add items',
  },
  selectedCount: {
    id: 'AddItemsPanel.selectedCount',
    defaultMessage: '{count} selected',
    description: 'Count of selected items',
  },
});

export const AddItemsFooter = ({
  selectedIds,
  step,
  onNext,
  onBack,
}: AddItemsFooterProps) => {
  const { formatMessage } = useIntl();

  const cancelText = formatMessage(
    step === 'select-items' ? messages.cancel : messages.back,
  );
  const nextText = formatMessage(
    step === 'select-items' ? messages.nextLink : messages.addItems,
  );

  return (
    <Layout align="center" justify="space-between" w="100%">
      <Text>
        {formatMessage(messages.selectedCount, { count: selectedIds.length })}
      </Text>
      <Layout align="center" spacing={2}>
        <Button text={cancelText} variant="tertiary" onClick={onBack} />
        <Button
          text={nextText}
          variant="primary"
          onClick={onNext}
          disabled={selectedIds.length === 0}
        />
      </Layout>
    </Layout>
  );
};
